export const userTypes = {
  maintainer: 'maintainer',
};

export const notAllowedUserLoginText =
  'You do not have permission to login as a support staff member. Contract your OurPetPolicy admin for further assistance.';
